export function createRawMediaSize(size) {
  return `(min-width: ${size}px)`
}
